import Crud from '../components/ReserveVehicles/Crud'
import Entity from '../components/ReserveVehicles/Add'
import View from '../components/ReserveVehicles/View'

let routes = {
    path: '/reserveVehicles',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/myreserves/add',
            name: 'Reservar Veículo',
            component: Entity
        },
        {
            path: '/myreserves/edit/:id?',
            name: 'Editar Reserva',
            component: Entity
        },
        {
            path: '/reserveVehicles',
            name: 'Reservas de Veículos',
            component: Crud
        },
        {
            path: '/myreserves/view/:id?',
            name: 'Visualização de Reserva',
            component: View
        },
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/reserveVehicles.js